import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetPolicyByIdDTO } from '@/api/policies/get-policy-by-id'

export const mockGetPolicyById = http.get(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies/:policyId',
  () => {
    const data: GetPolicyByIdDTO = {
      data: {
        checkout: {
          category: 'checkout',
          checkoutIntegration: faker.helpers.arrayElement([
            'NO_FILTERS',
            'B2B_CHECKOUT',
            'B2B_CHECKOUT_AND_PAYMENT_SPLIT',
          ]),
        },
        generalConfiguration: {
          category: 'general_configurations',
          netCommissioned: faker.datatype.boolean(),
          residentialProperties: faker.datatype.boolean(),
          touristTax: faker.datatype.boolean(),
        },
        regionMaxValue: {
          category: 'region_max_value',
          regionMaxValues: Array.from({ length: 5 }).map(() => ({
            cityName: faker.location.city(),
            stateSymbol: faker.helpers.arrayElement(['SP', 'RJ', 'MG', 'ES']),
            maxPrice: faker.number.int({ min: 100, max: 1000 }) * 100,
          })),
        },
        hotelRating: {
          category: 'hotel_rating',
          minHotelRate: faker.helpers.arrayElement([
            'ONE_STAR',
            'TWO_STARS',
            'THREE_STARS',
            'FOUR_STARS',
            'FIVE_STARS',
            'SIX_STARS',
            'NONE',
          ]),
        },
        mealPlan: {
          category: 'meal_plan',
          mealPlans: Array.from({ length: 5 }).map(() =>
            faker.helpers.arrayElement(['NM', 'BF', 'HB', 'HL', 'HD', 'AI']),
          ),
        },
        paymentConfiguration: {
          categoryCode: 'payment_method',
          paymentConfigurations: [
            {
              type: 'direto',
              active: faker.datatype.boolean(),
              commissioned: faker.datatype.boolean(),
              corporateRate: faker.datatype.boolean(),
              net: faker.datatype.boolean(),
              preferableType: faker.datatype.boolean(),
              publicRate: faker.datatype.boolean(),
            },
            {
              type: 'faturado',
              active: faker.datatype.boolean(),
              commissioned: faker.datatype.boolean(),
              corporateRate: faker.datatype.boolean(),
              net: faker.datatype.boolean(),
              preferableType: faker.datatype.boolean(),
              publicRate: faker.datatype.boolean(),
              dailyAndTaxes: false,
              dailyAndTaxesExtra: false,
              preferableDailyAndTaxes: false,
              preferableDailyAndTaxesExtra: false,
            },
            {
              type: 'cartaovi',
              active: faker.datatype.boolean(),
              commissioned: faker.datatype.boolean(),
              corporateRate: faker.datatype.boolean(),
              net: faker.datatype.boolean(),
              preferableType: faker.datatype.boolean(),
              publicRate: faker.datatype.boolean(),
              dailyAndTaxes: false,
              dailyAndTaxesExtra: false,
              preferableDailyAndTaxes: false,
              preferableDailyAndTaxesExtra: false,
            },
          ],
        },
        refundable: {
          category: 'refundable',
          refundableRates: faker.datatype.boolean(),
          cancelableRates: faker.datatype.boolean(),
        },
      },
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
